import axios from 'shared/api/axios';

export const getSettings = async () => {
  const res = await axios.get('/api/v1/ai-chatbots/inbound-ai-rep/settings');
  return res.data;
};
